export const CREATING_PACKAGE = "CREATING_PACKAGE";
export const UPDATING_PACKAGE = "UPDATING_PACKAGE";
export const PACKAGE_CREATED = "PACKAGE_CREATED";
export const PACKAGE_UPDATED = "PACKAGE_UPDATED";
export const ERROR_PACKAGE_CREATE = "ERROR_PACKAGE_CREATE";
export const ERROR_PACKAGE_UPDATE = "ERROR_PACKAGE_UPDATE";
export const UPDATED_RECENTLY = "UPDATED_RECENTLY";
export const SET_UPDATED_RECENTLY_TO_FALSE = "SET_UPDATED_RECENTLY_TO_FALSE";
